import React, { Component } from 'react';

class ReservationsHistorical extends Component {
    render() {
        return (
            <div>
                Reservas / Historial
            </div>
        );
    }
}

ReservationsHistorical.propTypes = {

};

export default ReservationsHistorical;